<template>
    <b-modal ref="profile_modal" size="xl" bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
        <div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.doc.id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="p-4" v-if="!is_load">
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        ID
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" disabled type="text" class="form-control" v-model="doc.id">
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Email
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="doc.source">
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        Пересилати на:
                    </label>
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <textarea id="advanced_name" type="text" class="form-control" v-model="doc.destination" />
                    </div>
                </div>
            </div>
        </div>
        
        <template v-slot:modal-footer="{close}">
            <div class="modal-footer w-100">
                
                <button type="button" v-on:click="remove_item" class="btn btn-outline-danger waves-effect waves-themed mr-5">
                    Видалити
                </button>
                
                <button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed ml-5">
                    Закрити
                </button>
                
                <button type="button" v-on:click="save_doc" class="btn btn-success waves-effect waves-themed">
                    Зберегти
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script >

export default {
    name: "edit_email_forward",
    
    created() {
        EventBus.$on("edit_email_forward", this.edit_doc);
    },
    
    data() {
        return {
            modal_position: "right",
            is_show_modal: false,
            is_load: false,
            doc: {
                id: 0,
                source : "",
                destination : "",
            },
            
        }
    },
    
    methods: {
        
        close_modal() {
            this.close();
        },
        
        close() {
            this.doc = this.default_item;
            this.is_show_modal = false;
        },
        
        edit_doc(doc_id) {
            this.load_item(doc_id);
        },
        
        
        async remove_item() {
            await api.delete('/email/redirect/' + this.doc.id).then(({data}) => {
                if (data.status === "operation_success") {
                    window.location.reload();
                }
            }).catch(err => {
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
            .finally(() => {
                IMC_CORE.hideloading();
                this.close();
            });
        },
        
        
        async load_item(id) {
            this.is_load = true;
            this.doc = this.default_item;
            IMC_CORE.showloading();
            await api.get('/email/redirect/' + id).then(({data}) => {
                this.is_show_modal = true;
                if (data.status === "operation_success") {
                    this.doc = data.data;
                }
                
            }).catch(err => {
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
                .finally(() => {
                    IMC_CORE.hideloading();
                    this.is_load = false;
                });
        },
        
        async save_doc() {
            await api.put('/email/redirect/' + this.doc.id,this.doc).then(({data}) => {
                if (data.status === "operation_success") {
                    this.doc = data.data;
                }
                this.close_modal();
            }).catch(err => {
                console.log(err);
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
                .finally(() => {
                    IMC_CORE.hideloading();
                    this.is_load = false;
                });
        }
        
    },
    
    computed: {
        default_item() {
            return {
                id: 0,
                source : "",
                destination : "",
            }
        },
        
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-xl";
            }
            
            return "modal-dialog-right modal-xl";
        },
    }
}
</script>


<style scoped>

</style>